<template>
  <section class="newsletter">
    <div class="container flex">
      <div class="newsletter-title">
        <p>Subscribe to our Newsletter</p>
      </div>
      <div class="newsletter-form">
        <form action="https://consultancysquad.us5.list-manage.com/subscribe/post" method="POST">
          <input type="hidden" name="u" value="cfc60c89997048a4f71049389">
          <input type="hidden" name="id" value="a60e143ef3">
          <input type="hidden" name="ht" value="52fd80e4acada36064899313dd92b1e8d00901df:MTU4OTg3OTkwMS45OTQ=">
          <input type="hidden" name="mc_signupsource" value="hosted">
          <!-- people should not fill these in and expect good things -->
          <div>
            <input v-hover type="text" name="MERGE1" id="MERGE1" size="25" value="" tabindex="-1" placeholder="Name" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none">
          </div>
          <div>
            <input v-hover type="email" autocapitalize="off" autocorrect="off" name="MERGE0" id="MERGE0" size="25" value="" placeholder="Email" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none">
          </div>
          <input v-hover type="submit" class="btn shadow w-full focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded" name="submit" value="Subscribe">
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints";
@import '../../assets/styles/variables';
.newsletter {
  padding: 40px 0;
  .container {
    @include breakpoint(sm) {
      flex-wrap: wrap;
    }
  }
  .newsletter-title {
    flex: 190px 0 0;
    padding-right: 40px;
    border-right: 1px solid rgba($sage, 0.5%);
    @include breakpoint(sm) {
      flex: 1;
      border-right: none;
      padding: 0 0 20px 0;
      text-align: center;
    }
    p {
      color: $sage;
      font-weight: 500;
    }
  }
  .newsletter-form {
    width: 100%;
    form {
      display: flex;
      height: 100%;
      padding-left: 10px;
      justify-content: center;
      align-items: center;
      @include breakpoint(sm) {
        flex-wrap: wrap;
      }
      div {
        padding: 0 10px;
        display: flex;
        flex: auto;
        align-items: center;
        @include breakpoint(sm) {
          flex: 50% 0 0;
          margin-bottom: 20px;
        }
        input {
          width: 100%;
          font-weight: 400;
          border: 1px solid $sage;
          &:focus {
            box-shadow: 0 0 0 1px rgba($gold, 0.5);
          }
        }
      }
      .btn {
        flex: 130px 0 0;
        margin-left: 10px;
        background: $gold;
        font-weight: 400;
        transition: background 0.2s ease-in;
        &:hover {
          background: lighten($gold, 5%);
        }
        @include breakpoint(sm) {
          flex: 100% 0 0;
        }
      }
    }
  }
}
</style>
